import axios from 'axios';
import apiroutes from '@/API/ApiRoutes';


const state = {};

const getters = {};

const actions = {
  LoggedUser({ commit }, payload) {

    return new Promise((resolve, reject) => {
      let tok = '';
      let auth = JSON.parse(localStorage.getItem('auth-response'));
      if (auth){
        tok= 'Bearer '+auth.access_token;
      }else{
        tok= '';
      }

      let authheader = {
        "Accept": "application/json",
          "Content-Type": "application/json",
          Authorization : tok
      };

      axios.get(apiroutes.routes.loggeduser, {headers: authheader})
        .then((response) => {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  SaveProfile({commit}, payload) {
    return new Promise((resolve, reject) => {
      let tok = '';
      let auth = JSON.parse(localStorage.getItem('auth-response'));
      if (auth){
        tok= 'Bearer '+auth.access_token;
      }else{
        tok= '';
      }
      let authheader = {
          "Accept": "application/json",
          "Content-Type": "application/json",
          Authorization : tok
      };
      let id = JSON.parse(localStorage.getItem('user-response'));
      axios.post(apiroutes.routes.url + '/users/' +id.data.id+'/profile', payload,
        {headers: authheader})
        .then((response) => {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
};
const mutations = {};
export default {
  state,
  getters,
  actions,
  mutations
};
